import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import DistributorRegister from "@/pages/DistributorRegister";
import Dashboard from "@/pages/Dashboard";
import Distributors from "@/pages/Distributors";
import Dealers from "@/pages/Dealers";
import Stock from "@/pages/Stock";
import Installations from "@/pages/Installations";
import Warranties from "@/pages/Warranties";
import Reports from "@/pages/Reports";
import AuditLog from "@/pages/AuditLog";
import Allocation from "@/pages/Allocation";
import Terms from "@/pages/Terms";
import Settings from "@/pages/Settings";
import Layout from "@/components/Layout";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#FFFFFF] text-slate-900 text-sm">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter basename="/warranty">
        <Toaster position="top-right" theme="light" richColors />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register-distributor" element={<DistributorRegister />} />
          <Route path="/app" element={<Protected><Dashboard /></Protected>} />
          <Route path="/app/distributors" element={<Protected><Distributors /></Protected>} />
          <Route path="/app/dealers" element={<Protected><Dealers /></Protected>} />
          <Route path="/app/stock" element={<Protected><Stock /></Protected>} />
          <Route path="/app/installations" element={<Protected><Installations /></Protected>} />
          <Route path="/app/warranties" element={<Protected><Warranties /></Protected>} />
          <Route path="/app/reports" element={<Protected><Reports /></Protected>} />
          <Route path="/app/allocation" element={<Protected><Allocation /></Protected>} />
          <Route path="/app/terms" element={<Protected><Terms /></Protected>} />
          <Route path="/app/settings" element={<Protected><Settings /></Protected>} />
          <Route path="/app/audit" element={<Protected><AuditLog /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
